import "./App.css";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

import Navbar from "./Components/Navbar/Navbar";
import Greeting from "./Components/Greeting/Greeting";
import Work from "./Components/Work/Work";
import AboutMe from "./Components/AboutMe/AboutMe";
import Footer from "./Components/Footer/Footer";

import Projectra from "./Components/Projects/Projectra";
import ProjectraLO from "./Components/Projects/ProjectraLO";
import Husman from "./Components/Projects/Husman";
import ThisPF from "./Components/Projects/ThisPF";
import Period from "./Components/Projects/Period";

// Layout som delas av alla sidor (Navbar + Footer)
function Layout() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <div className="app-shell">
        <Outlet />
      </div>

      {/* Global footer: syns på alla sidor */}
      <Footer />
    </>
  );
}

// Startsida-innehåll (utan Footer här, annars blir det dubbelt)
function Home() {
  return (
    <>
      {/* TOP / HERO */}
      <div id="top" className="greeting-slider-wrapper">
        <Greeting />
      </div>

      {/* WORK */}
      <section id="work">
        <Work />
      </section>

      {/* ABOUT */}
      <section id="about">
        <AboutMe />
      </section>

      {/* CONTACT anchor (om du vill att navbar-länk #contact ska funka på /) */}
      <section id="contact" style={{ height: 1 }} />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />

          <Route path="/project/projectra" element={<Projectra />} />
          <Route path="/project/projectra-logo" element={<ProjectraLO />} />
          <Route path="/project/svensk-husman-game" element={<Husman />} />
          <Route path="/project/this-portfolio" element={<ThisPF />} />
          <Route path="/project/period" element={<Period />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;





